module.exports = __webpack_public_path__ + "img/icon-tiktok.ac483e20.svg";